<div (click)="openDialog()" class="trigger">
  <ng-content></ng-content>
</div>

<ng-template #dialogContent>
  @if (shoppingLists() || errorText()) {
    <ui-add-to-shopping-list
      (abortClicked)="closeDialog()"
      (closeClicked)="closeDialog()"
      (retryClicked)="retry()"
      (submitResult)="onSubmit($event)"
      [defaultAmount]="amount"
      [error]="errorText()"
      [hidden]="loading()"
      [label]="label"
      [shoppingLists]="shoppingLists()"
      [sku]="sku"
    >
    </ui-add-to-shopping-list>
  }
  @if (loading()) {
    <ui-spinner></ui-spinner>
  }
</ng-template>
